/**
 * Visually-obvious stand-in for imagery not yet sourced. The diagonal
 * hatch + "placeholder" badge make it impossible to mistake for final art
 * in review. Replace usages with a real image once assets land (AHD-6064).
 */
export function PlaceholderMedia({
  label,
  className = "",
}: {
  label: string
  className?: string
}) {
  return (
    <div
      data-testid="placeholder-media"
      data-placeholder="true"
      role="img"
      aria-label={`Placeholder: ${label}`}
      className={`relative flex items-end overflow-hidden rounded-[16px] bg-neutral-200 ${className}`}
      style={{
        backgroundImage:
          "repeating-linear-gradient(45deg, rgba(0,0,0,0.04) 0 12px, rgba(0,0,0,0) 12px 24px)",
      }}
    >
      <span className="type-label-sm absolute top-2 right-2 rounded-full bg-neutral-900/80 px-2 py-0.5 text-white">
        Placeholder
      </span>
      <span className="type-body-sm m-4 font-medium text-neutral-700">
        {label}
      </span>
    </div>
  )
}
